import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { InitializeTokens } from "./helpers/initialize";
import "./App.css";

// actions
import { initializeTokens as InitializeTokensRD } from "./redux/actions/tokens";

// pages
import Layout from "./components/Layout";
import Liquidity from "./pages/Liquidity/Liquidity";
import AddLiquidity from "./pages/Liquidity/AddLiquidity";
import RemoveLiquidity from "./pages/Liquidity/RemoveLiquidity";
import Swap from "./pages/Swap";
import Farms from "./pages/Earn/Farms";
import Pools from "./pages/Earn/Pools";
import Explore from "./pages/Explore";
import TokenPage from "./pages/Explore/TokenPage";
import PoolPage from "./pages/Explore/PoolPage";

import NotFound from "./pages/NotFound";

function AppRouter() {
  const dispatch = useDispatch();

  useEffect(() => {
    async function load() {
      // tokens
      let tokens = await InitializeTokens();
      dispatch(InitializeTokensRD(tokens));
    }
    load();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Navigate replace to="/swap" />} />

          <Route path="/liquidity">
            <Route index element={<Liquidity />} />
            <Route path="add">
              <Route index element={<AddLiquidity />} />
              <Route path=":token_a/:token_b" element={<AddLiquidity />} />
            </Route>
            <Route path="remove">
              <Route index element={<RemoveLiquidity />} />
              <Route path=":token_a/:token_b" element={<RemoveLiquidity />} />
            </Route>
          </Route>

          <Route path="/earn">
            <Route index element={<Navigate replace to="/earn/farms" />} />
            <Route path="farms" element={<Farms />} />
            <Route path="pools" element={<Pools />} />
          </Route>

          <Route path="/swap" element={<Swap />} />
          <Route path="/explore">
            <Route index element={<Navigate replace to="/explore/tokens" />} />
            <Route path="tokens" element={<Explore tab="tokens" key="tokens" />} />
            <Route path="pools" element={<Explore tab="pools" key="pools" />} />
            <Route path="tokens/:id" element={<TokenPage />} />
            <Route path="pools/:id" element={<PoolPage />} />
          </Route>
          <Route path="/dashboard" element={<Navigate replace to="/explore" />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRouter;
